<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Lista de Produtos</h1>
            <p class="welcome-message">Gerenciamento de produtos</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
          @if (selection.hasValue()) {
          <span>Ações ({{ selection.selected.length }})</span>
          } @else {
          <span>Ações</span>
          }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #opcoesMenu="matMenu">
          <button mat-menu-item (click)="imprimirRelatorio()">
            <mat-icon class="material-symbols-outlined">print</mat-icon>
            <span>Imprimir relatório</span>
          </button>
          <button mat-menu-item routerLink="/cadastros/produtos/reajuste-precos" [queryParams]="{ origem: 'produtos' }">
            <mat-icon class="material-symbols-outlined">price_change</mat-icon>
            <span>Reajustar preços dos produtos</span>
          </button>
          @if (selection.hasValue()) {
          <button mat-menu-item (click)="editarEmMassa()">
            <mat-icon class="material-symbols-outlined">edit_note</mat-icon>
            <span>Editar dados em massa</span>
          </button>
          <button mat-menu-item (click)="alterarTags()">
            <mat-icon class="material-symbols-outlined">label</mat-icon>
            <span>Alterar tags</span>
          </button>
          <button mat-menu-item (click)="imprimirEtiquetas()">
            <mat-icon class="material-symbols-outlined">label</mat-icon>
            <span>Imprimir etiquetas</span>
          </button>
          <button mat-menu-item (click)="abrirModalExcluir()">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
            <span>Excluir produto</span>
          </button>
          } @else {
          <button mat-menu-item (click)="exportarProdutos()">
            <mat-icon class="material-symbols-outlined">file_upload</mat-icon>
            <span>Exportar produtos para planilha</span>
          </button>
          <button mat-menu-item (click)="exportarKits()">
            <mat-icon class="material-symbols-outlined">file_upload</mat-icon>
            <span>Exportar composição de kits para planilha</span>
          </button>
          <button mat-menu-item (click)="exportarFabricados()">
            <mat-icon class="material-symbols-outlined">file_upload</mat-icon>
            <span>Exportar estrutura de fabricados para planilha</span>
          </button>
          <button mat-menu-item (click)="importarProdutos()">
            <mat-icon class="material-symbols-outlined">file_download</mat-icon>
            <span>Importar produtos de uma planilha</span>
          </button>
          }
        </mat-menu>

        <button type="button" mat-flat-button class="btn-primary" routerLink="/cadastros/produtos/cadastrar">
          <mat-icon class="material-symbols-outlined">add</mat-icon>
          Novo Produto
        </button>
      </div>
    </div>

    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" formControlName="pesquisa"
              placeholder="Pesquise por nome, código (SKU) ou GTIN/EAN" />

            <button mat-icon-button matSuffix [matMenuTriggerFor]="refinarMenu" type="button" aria-label="Refinar Busca"
              matTooltip="Refinar busca">
              <mat-icon>tune</mat-icon>
            </button>
            <mat-menu #refinarMenu="matMenu">
              <button mat-menu-item (click)="filtroRefinar = null">
                @if (filtroRefinar === null) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== null">Não refinar</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _produtoListaRefinamentoEnum.CodigoSku">
                @if (filtroRefinar === _produtoListaRefinamentoEnum.CodigoSku) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _produtoListaRefinamentoEnum.CodigoSku">Código</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _produtoListaRefinamentoEnum.CodigoFornecedor">
                @if (filtroRefinar === _produtoListaRefinamentoEnum.CodigoFornecedor) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _produtoListaRefinamentoEnum.CodigoFornecedor">Código do
                  Fornecedor</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _produtoListaRefinamentoEnum.GtinEan">
                @if (filtroRefinar === _produtoListaRefinamentoEnum.GtinEan) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _produtoListaRefinamentoEnum.GtinEan">GTIN/EAN</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _produtoListaRefinamentoEnum.Descricao">
                @if (filtroRefinar === _produtoListaRefinamentoEnum.Descricao) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _produtoListaRefinamentoEnum.Descricao">Descrição</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _produtoListaRefinamentoEnum.PalavrasChave">
                @if (filtroRefinar === _produtoListaRefinamentoEnum.PalavrasChave) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _produtoListaRefinamentoEnum.PalavrasChave">Palavras-chave</span>
              </button>
            </mat-menu>

            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 filter-container">
          <button mat-stroked-button type="button" class="btn-filter" [matMenuTriggerFor]="filtroMenu"
            [matBadge]="qtdFiltrosAvancados" [matBadgeHidden]="qtdFiltrosAvancados === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>
          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content" [formGroup]="model">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros Avançados</h6>

                <div class="filter-menu__form">
                  <!-- Categoria -->
                  <app-select-pesquisavel label="Categoria" [control]="$any(model.get('idCategoria'))" [idField]="'id'"
                    [nameField]="'descricao'" [offlineList]="listaCategoria" [isOptional]="true"
                    hint="Selecionar Categoria">
                  </app-select-pesquisavel>

                  <!-- Fornecedor -->
                  <!-- TODO: Link correct API URL for suppliers -->
                  <app-select-pesquisavel label="Fornecedor" [control]="$any(model.get('idFornecedor'))"
                    [idField]="'id'" [nameField]="'descricao'" [apiUrl]="urlFornecedor" [isOptional]="true"
                    hint="Selecione um fornecedor">
                  </app-select-pesquisavel>

                  <!-- Marca -->
                  <app-select-pesquisavel label="Marca" [control]="$any(model.get('idMarca'))" [idField]="'id'"
                    [nameField]="'descricao'" [offlineList]="listaMarca" [isOptional]="true" hint="Selecione uma marca">
                  </app-select-pesquisavel>

                  <!-- NCM -->
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Buscar por NCM</mat-label>
                    <input matInput type="text" inputmode="numeric" formControlName="ncm" [mask]="masks.ncm"
                      placeholder="Ex: 0101.21.00, 0101 (posição)" (keydown)="onNcmKeydown($event)" />
                    <button mat-icon-button matSuffix type="button" matTooltip="Pesquisar NCM" (click)="pesquisarNcm()">
                      <mat-icon>search</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- Tags -->
                  <app-select-pesquisavel label="Tags de produtos" [control]="$any(model.get('listIdTag'))"
                    [idField]="'idTag'" [nameField]="'nome'" [offlineList]="listaTag" [multiple]="true"
                    [isOptional]="true" hint="Selecione tags">
                  </app-select-pesquisavel>

                  <!-- Tipo de Produto -->
                  <app-select-pesquisavel label="Tipo de Produto" [control]="$any(model.get('listIdTipoProduto'))"
                    [idField]="'id'" [nameField]="'descricao'" [offlineList]="listaTipoProduto" [multiple]="true"
                    [isOptional]="true" hint="Selecione o tipo de produto">
                  </app-select-pesquisavel>
                </div>
              </div>

              <div class="filter-menu__actions">
                <button mat-button class="btn-secondary" matMenuClose>Cancelar</button>
                <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>
                  Aplicar
                </button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>

          <button mat-stroked-button type="button" class="btn-filter desktop-view" (click)="configurarColunas()">
            <mat-icon>view_column</mat-icon>
            Configurar Colunas
          </button>
        </div>
      </div>
    </form>

    @if (_listaProdutoResponse && _dataSource.data.length > 0) {
    <table mat-table class="desktop-view" [dataSource]="_flatDataSource" matSort (matSortChange)="onSortChange($event)">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="w-checkbox">
          <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
            [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="w-checkbox variation-checkbox">
          <div class="checkbox-indent" [style.transform]="row.isVariation ? 'translateX(20px)' : 'translateX(0px)'">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? toggleSelection(row.data) : null"
              [checked]="selection.isSelected(row.data)" [aria-label]="checkboxLabel(row.data)">
            </mat-checkbox>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="descricao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
        <td mat-cell *matCellDef="let row">
          @if (row.isVariation) {
          <span class="variation-indent">
            <mat-icon class="variation-icon">subdirectory_arrow_right</mat-icon>
            {{ row.data.descricao }}
          </span>
          } @else {
          {{ row.data.descricao }}
          @if (row.data.variacoes?.length) {
          <span class="badge-variacoes">
            {{ row.data.variacoes.length }} variações
            <mat-icon class="icon-expand">{{
              expandedElements.has(row.data) ? 'expand_less' : 'expand_more'
              }}</mat-icon>
          </span>
          }
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="preco">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Preço</th>
        <td mat-cell *matCellDef="let row" class="text-end">
          {{ row.data.preco | abnt:'preco' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="codigoSku">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>SKU</th>
        <td mat-cell *matCellDef="let row">{{ row.data.codigoSku }}</td>
      </ng-container>

      <ng-container matColumnDef="gtinEan">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>GTIN/EAN</th>
        <td mat-cell *matCellDef="let row">{{ row.data.gtinEan }}</td>
      </ng-container>

      <ng-container matColumnDef="unidade">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Unidade</th>
        <td mat-cell *matCellDef="let row">{{ row.data.unidade }}</td>
      </ng-container>

      <ng-container matColumnDef="ncm">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>NCM</th>
        <td mat-cell *matCellDef="let row">{{ row.data.ncm | mask: '0000.00.00' }}</td>
      </ng-container>

      <ng-container matColumnDef="custo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Custo</th>
        <td mat-cell *matCellDef="let row" class="text-end">
          {{ row.data.custo | currency: 'BRL' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="marca">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Marca</th>
        <td mat-cell *matCellDef="let row">{{ row.data.marca }}</td>
      </ng-container>

      <ng-container matColumnDef="tipoProduto">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
        <td mat-cell *matCellDef="let row">{{ row.data.tipoProduto }}</td>
      </ng-container>

      <ng-container matColumnDef="codFornecedor">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Cód. Fornecedor</th>
        <td mat-cell *matCellDef="let row">{{ row.data.codFornecedor }}</td>
      </ng-container>

      <ng-container matColumnDef="tags">
        <th mat-header-cell *matHeaderCellDef>Tags</th>
        <td mat-cell *matCellDef="let row">
          <div class="tags-container">
            @for (tag of row.data.tags; track tag.idTag) {
            <app-ui-tag [text]="tag.nome" [bgColor]="tag.cor"></app-ui-tag>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="estoqueFisico">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Estoque Físico</th>
        <td mat-cell *matCellDef="let row" class="text-end">
          {{ row.data.saldoFisico | abnt:'quantidade' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="estoqueDisponivel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Estoque Disponível</th>
        <td mat-cell *matCellDef="let row" class="text-end">
          {{ row.data.saldoDisponivel | abnt:'quantidade' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
        <td mat-cell *matCellDef="let row" class="text-center">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações" (click)="$event.stopPropagation()">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item [routerLink]="['/cadastros/produtos/cadastrar', { idProduto: row.data.idProduto }]">
              <span class="material-symbols-outlined">edit</span>
              <span>Editar</span>
            </button>
            <button mat-menu-item (click)="imprimirEtiquetas(row.data)">
              <span class="material-symbols-outlined">label</span>
              <span>Imprimir etiquetas</span>
            </button>
            <button mat-menu-item (click)="abrirModalExcluir(row.data)">
              <span class="material-symbols-outlined">delete</span>
              <span>Excluir</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.variation-row]="row.isVariation"
        [class.parent-expanded-row]="!row.isVariation && expandedElements.has(row.data)" (click)="toggleRow(row)"
        [style.cursor]="row.data.variacoes?.length ? 'pointer' : 'default'"></tr>
    </table>

    <div class="mobile-view">
      @for (produto of _dataSource.data; track produto.idProduto) {
      <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(produto)">
        <div class="card-header-mobile d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-2">
            <mat-checkbox (change)="$event ? toggleSelection(produto) : null" [checked]="selection.isSelected(produto)"
              color="primary">
            </mat-checkbox>
            <div class="product-thumb-mobile">
              <mat-icon class="material-symbols-outlined">image</mat-icon>
            </div>
            <div class="d-flex flex-column">
              <span class="text-bold">{{ produto.descricao }}</span>
              @if (produto.codigoSku) {
              <small>SKU: {{ produto.codigoSku }}</small>
              }
            </div>
          </div>
          <button mat-icon-button [matMenuTriggerFor]="menuMobile">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #menuMobile="matMenu">
            <button mat-menu-item [routerLink]="['/cadastros/produtos/cadastrar', { idProduto: produto.idProduto }]">
              Editar
            </button>
            <button mat-menu-item (click)="imprimirEtiquetas(produto)">Imprimir etiquetas</button>
            <button mat-menu-item (click)="abrirModalExcluir(produto)">Excluir</button>
          </mat-menu>
        </div>
        <div class="card-body-mobile p-3">
          <div class="row">
            <div class="col-6 mb-2">
              <small class="d-block">Preço</small>
              <span class="text-bold">{{ produto.preco | abnt:'preco' }}</span>
            </div>
            <div class="col-6 mb-2">
              <small class="d-block">Estoque Disp.</small>
              <span>{{ produto.saldoDisponivel | abnt:'quantidade' }}</span>
            </div>
          </div>

          @if (produto.tags?.length) {
          <div class="mb-2">
            <div class="tags-container">
              @for (tag of produto.tags; track tag.idTag) {
              <app-ui-tag [text]="tag.nome" [bgColor]="tag.cor"></app-ui-tag>
              }
            </div>
          </div>
          }

          <!-- Variations Section -->
          @if (produto.variacoes?.length) {
          <div class="mt-3">
            <button mat-button color="primary" (click)="toggleExpand(produto)" class="w-100 text-start ps-0">
              <mat-icon>{{ expandedElements.has(produto) ? 'expand_less' : 'expand_more' }}</mat-icon>
              {{ produto.variacoes.length }} Variações
            </button>

            @if (expandedElements.has(produto)) {
            <div class="variations-mobile-list">
              @for (variation of produto.variacoes; track variation.idProduto) {
              <div class="variation-item" [class.selected-card]="selection.isSelected(variation)">
                <div class="d-flex justify-content-between align-items-start">
                  <div class="d-flex align-items-center gap-2">
                    <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? toggleSelection(variation) : null" [checked]="selection.isSelected(variation)"
                      color="primary">
                    </mat-checkbox>
                    <div class="d-flex flex-column">
                      <strong>{{ variation.descricao }}</strong>
                      <span>{{ variation.preco | currency: 'BRL' }}</span>
                    </div>
                  </div>
                  <button mat-icon-button [matMenuTriggerFor]="menuVariationMobile" class="scale-08">
                    <span class="material-symbols-outlined">more_horiz</span>
                  </button>
                  <mat-menu #menuVariationMobile="matMenu">
                    <button mat-menu-item [routerLink]="[
                                  '/cadastros/produtos/cadastrar',
                                  { idProduto: variation.idProduto },
                                ]">
                      Editar
                    </button>
                    <button mat-menu-item (click)="imprimirEtiquetas(variation)">
                      Imprimir etiquetas
                    </button>
                    <button mat-menu-item (click)="abrirModalExcluir(variation)">Excluir</button>
                  </mat-menu>
                </div>
                <div class="d-flex justify-content-between small mt-1 ps-5">
                  <span>SKU: {{ variation.codigoSku }}</span>
                  <span>Estoque: {{ variation.saldoDisponivel | abnt:'quantidade' }}</span>
                </div>
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="col-12 text-center">
      <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
        @if (_isLoading === true) {
        <mat-spinner [diameter]="20"></mat-spinner>
        } @else {
        <span class="material-symbols-outlined">expand_more</span>
        Ver Mais
        }
      </button>
    </div>
    } @else if (_isLoading === true && _dataSource.data.length === 0) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else {
    <app-empty-list [title]="'Nenhum produto encontrado'"
      [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
    }
  </div>
</div>